/**
 * @module appLoader
 *
 * @fileOverview A bootstrap mechanism, which runs a series of Promise before
 * running a callback.
 */

import MissionControl from '@/sdk/missionControl'
import {
  fetchConfig,
  getAndSaveConfigToken,
  refreshUserToken,
} from '@/sdk/oauth'
import store from '@/store'

const logger = require('debug')('careship:app-loader')

/**
 * @param {Function} callback
 */
export default function (callback: Function) {
  ;(async () => {
    if (process.env.NODE_ENV !== 'production') {
      localStorage.setItem('debug', 'careship:*')
    }

    /**
     * APP LOADER - FIRST STAGE
     */

    logger('appLoader -> first stage')

    await getAndSaveConfigToken()

    /**
     * APP LOADER - SECOND STAGE
     */

    logger('appLoader -> second stage')

    await Promise.all([
      store.dispatch('initLanguage'),

      refreshUserToken(),

      // Get and save the config in Mission Control (MC no longer builds the request, we pass it a fetching method)
      MissionControl.init({
        request: fetchConfig,
      }),
    ])

    await store.dispatch('definitions/getAllDefinitions')

    /**
     * APP LOADER - FINAL CHECKS
     */

    if (store.getters['auth/isAuthenticated']()) {
      logger('user is authenticated, will attempt to redirect')

      await store.dispatch('user/emailVerificationStatus')
    }

    if (!MissionControl.isReadyForQueries()) {
      throw new Error('Mission Control failed to launch.')
    }

    callback()
  })()
}
